module.exports = __webpack_public_path__ + "img/icon_sport_type_31.7e8460a1.png";